// Lettvekts markdown-renderer for AI-genererte avtaletekster (overskrifter, punkter, **fet**).
function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : <span key={i}>{p}</span>
  );
}

export function SimpleMarkdown({ text, className = "" }) {
  const lines = (text || "").split("\n");
  return (
    <div className={`space-y-1.5 text-sm leading-relaxed ${className}`}>
      {lines.map((raw, i) => {
        const s = raw.trim();
        if (!s) return <div key={i} className="h-1.5" />;
        if (s.startsWith("### ")) return <h4 key={i} className="pt-1 font-headings text-sm font-bold">{inline(s.slice(4))}</h4>;
        if (s.startsWith("## ")) return <h3 key={i} className="pt-2 font-headings text-base font-bold">{inline(s.slice(3))}</h3>;
        if (s.startsWith("# ")) return <h2 key={i} className="pt-2 font-headings text-base font-extrabold">{inline(s.slice(2))}</h2>;
        if (s.startsWith("- ") || s.startsWith("* "))
          return <div key={i} className="flex gap-2 pl-1"><span className="text-muted-foreground">•</span><span>{inline(s.slice(2))}</span></div>;
        return <p key={i}>{inline(s)}</p>;
      })}
    </div>
  );
}
